<template>
  <!-- 远传压力表 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="厂商">
              <a-input v-model="query.factory" placeholder="请输入厂商" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="物探点号">
              <a-input v-model="query.geophysicalPointNumber" placeholder="请输入连接点号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="压力表编号">
              <a-input v-model="query.piezometerNo" placeholder="请输入压力表编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="安装地址">
              <a-input v-model="query.installAddress" placeholder="请输入安装地址,支持模糊查询" allow-clear />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col :md="12" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()">新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button
                type="primary"
                style="margin-left: 8px"
                @click="exportHandle()"
                :loading="exportLoading"
                v-action:export
              >导出</a-button
              >
              <a-button
                type="primary"
                style="margin-left: 8px"
                @click="downloadTemplate({ excelForm: true })"
                v-action:upload
              >下载模板</a-button
              >
              <a-upload
                name="file"
                :multiple="false"
                :action="uploadUrl"
                :headers="uploadHeader"
                :show-upload-list="false"
                @change="uploadChange"
              >
                <a-button type="primary" style="margin-left: 8px" :loading="importLoading" v-action:import>
                  <a-icon type="upload" />导入
                </a-button>
              </a-upload>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      bordered
      :scroll="{ x: 2100 }"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>修改</a>
      </span>
      <span slot="createTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
    </a-table>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="log-form" :form="addOrUpdateForm">
        
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="厂商">
          <a-input
            placeholder="厂商"
            v-decorator="['factory', { rules: [{ required: true, message: '请输入厂商' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="压力表编号">
          <a-input
            placeholder="压力表编号"
            v-decorator="['piezometerNo', { rules: [{ required: true, message: '请输入压力表编号' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="压力采集间隔">
          <a-input
            placeholder="压力采集间隔"
            v-decorator="['collectionInterval', { rules: [{ required: true, message: '请输入压力采集间隔' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物探点">
          <a-input
            placeholder="物探点"
            v-decorator="['geophysicalPointNumber', { rules: [{ required: true, message: '请输入物探点' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="X坐标">
          <a-input
            placeholder="X坐标"
            v-decorator="['coordinatePointX', { rules: [{ required: true, message: '请输入X坐标' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="Y坐标">
          <a-input
            placeholder="Y坐标"
            v-decorator="['coordinatePointY', { rules: [{ required: true, message: '请输入Y坐标' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地面高程">
          <a-input
            placeholder="地面高程"
            v-decorator="['groundElevation', { rules: [{ required: true, message: '请输入地面高程' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装地址">
          <a-input
            placeholder="安装地址"
            v-decorator="['installAddress', { rules: [{ required: true, message: '请输入安装地址' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装日期">
          <a-input
            placeholder="安装日期"
            v-decorator="['installTime', { rules: [{ required: true, message: '请输入安装日期' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数据来源">
          <a-select
            placeholder="请选择数据来源"
            v-decorator="['datasource', { rules: [{ required: true, message: '请选择数据来源' }] }]"
          >
            <a-select-option :value="1">
              压力表
            </a-select-option>
            <a-select-option :value="2">
              远传计量表
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="高压报警值">
          <a-input-number
            style="width: 100%"
            placeholder="高压报警值"
            v-decorator="['highPressureValue', { rules: [{ required: true, message: '请输入高压报警值' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="低压报警值">
          <a-input-number
            style="width: 100%"
            placeholder="低压报警值"
            v-decorator="['lowPressureValue', { rules: [{ required: true, message: '请输入低压报警值' }] }]"
          />
        </a-form-item>
        <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预警值">
          <a-input-number
            style="width: 100%"
            placeholder="预警值"
            v-decorator="['prewarningValue', { rules: [{ required: true, message: '预警值' }] }]"
          />
        </a-form-item> -->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择">
          <a-tree-select
            :tree-data="zoneTreeData"
            v-decorator="['zoneId', { rules: [{ required: true, message: '请选择片区' }] }]"
            style="width: 100%"
            :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="请选择片区"
            allow-clear
            tree-default-expand-all
          ></a-tree-select>
        </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序">
          <a-input
            placeholder="排序"
            v-decorator="['sort', { rules: [{ required: true, message: '请输入排序' }] }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
const columns = [
  {
    title: '厂商',
    dataIndex: 'factory'
  },
  {
    title: '压力表编号',
    dataIndex: 'piezometerNo'
  },
  {
    title: '压力采集间隔',
    dataIndex: 'collectionInterval'
  },
  {
    title: '物探点',
    dataIndex: 'geophysicalPointNumber'
  },
  {
    title: 'X坐标',
    dataIndex: 'coordinatePointX'
  },
  {
    title: 'Y坐标',
    dataIndex: 'coordinatePointY'
  },
  {
    title: '地面高程',
    dataIndex: 'groundElevation'
  },
  {
    title: '安装地址',
    dataIndex: 'installAddress',
    ellipsis: true
  },
  {
    title: '安装日期',
    dataIndex: 'installTime'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 100,
    align:'center',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'PiezometerList',
  data () {
    return {
      currentId: '',
      queryUrl: '/pipe-network/piezometer/page',
      deleteUrl: '/pipe-network/piezometer',
      addOrUpdateUrl: '/pipe-network/piezometer',
      queryOneUrl: '/pipe-network/piezometer',
      exportDataUrl: 'pipe-network/piezometer/export',
      exportFileName: '远传压力表数据.xlsx',
      downloadTemplateUrl: 'pipe-network/piezometer/template/download',
      downloadTemplateName: '远传压力表.xlsx',
      uploadUrl: process.env.VUE_APP_API_BASE_URL + 'pipe-network/piezometer/import',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      zoneTreeData: [], // 分区数据选项
      importLoading: false,
      query: {
        geophysicalPointNumber: '',
        piezometerNo: '',
        factory: '',
        installAddress: '',
        tenantId: this.$store.state.user.info.tenantId
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },

  created () {
    this.getAllTenant()
    this.getZoneData()
  },
  methods: {
    // 重置
    // resetList() {
    //   this.pushTime = []
    //   this.collectionTime = []
    //   this.pagination.current = 1
    //   this.query = {}
    //   this.selectedRows = []
    //   this.queryList()
    // },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    uploadChange (info) {
      // 上传文件
      if (info.file.status !== 'uploading') {
        this.importLoading = true
      }
      if (info.file.status === 'done') {
        this.importLoading = false
        if (info.file.response.code !== 0) {
          this.$message.error(info.file.response.message)
        } else {
          this.$message.success(`${info.file.name} 上传成功`)
        }
        this.queryList()
      } else if (info.file.status === 'error') {
        this.importLoading = false
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
